import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useHasWorkDay = () => {
  const dataSettings = useSelector(dataSettingsSelector);
  const isUseSeparateWorkingDays = dataSettings.isUseSeparateWorkingDays;
  const isHasWorkDay = useMemo(() => {
    let temp = false;
    if (isUseSeparateWorkingDays) {
      temp =
        dataSettings.week_working_days.prepare.some((day) => day.enable === 1) &&
        dataSettings.week_working_days.delivery.some((day) => day.enable === 1);
    } else {
      temp = dataSettings.week_working_days.prepareAndDelivery.some((day) => day.enable === 1);
    }
    return temp;
  }, [
    dataSettings.week_working_days.delivery,
    dataSettings.week_working_days.prepare,
    dataSettings.week_working_days.prepareAndDelivery,
    isUseSeparateWorkingDays,
  ]);
  return { isHasWorkDay };
};
